import {createLazyFileRoute} from '@tanstack/react-router'

import Payment from '@/views/Payment/Payment'

export const Route = createLazyFileRoute('/_shop/payment/')({
  component: () => <Payment />,
})
